import React, { Fragment } from "react";
import styled from "styled-components";
import { color, link } from "src/styles/variables";
import { HelpEmail } from "src/react/components/help-email";
import { Button } from "src/react/components/button";

export const GenericErrorMessage = ({ children }) => (
  <Fragment>
    {children || <p>Sorry, something went wrong.</p>}
    <p>
      Please try again in a few minutes or{" "}
      <HelpEmail> get in touch with us</HelpEmail> if you need help with this.
    </p>
  </Fragment>
);

export const GenericError = () => (
  <ErrorWrapper data-selector="GenericError">
    <ErrorMessage>
      <GenericErrorMessage />
    </ErrorMessage>
  </ErrorWrapper>
);

export const GenericErrorWithRetry = ({ onRetry, customError }) => (
  <ErrorWrapper data-selector="GenericErrorWithRetry">
    <ErrorMessage>
      <p>{customError || "Sorry, something went wrong."}</p>
      <p>
        Please try again or <HelpEmail>send us an email</HelpEmail> if you need
        help with this.
      </p>
    </ErrorMessage>
    <Button
      data-selector="GenericErrorWithRetry-Button"
      align="center"
      onClick={onRetry}
      css="margin-top: 30px; margin-bottom: 10px"
    >
      Try again
    </Button>
  </ErrorWrapper>
);

export const GiftCardNotFoundError = () => (
  <ErrorWrapper>
    <ErrorMessage>
      <p>
        It looks like that code isn't valid. Please double-check the card, and
        if the problem persists, get in touch with <HelpEmail />.
      </p>
    </ErrorMessage>
  </ErrorWrapper>
);

export const EmailCheckError = () => (
  <ErrorBlockWithHelp>
    <p>There was a problem with trying to check your email.</p>
  </ErrorBlockWithHelp>
);

export const ErrorBlockWithHelp = ({ children, ...props }) => (
  <ErrorWrapper {...props}>
    <ErrorMessage>
      {children}
      <p>
        Please try again or <HelpEmail>send us an email</HelpEmail> if you need
        help with this.
      </p>
    </ErrorMessage>
  </ErrorWrapper>
);

export const ErrorMessage = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: ${color.torchRed};
  margin: 8px auto;
  a {
    ${link};
  }
`;

export const ErrorWrapper = styled.div`
  text-align: ${({ textAlign }) => textAlign || "center"};
  margin: ${({ margin }) => margin || "0 0 30px"};
`;
